export default __webpack_public_path__ + "static/media/twilio.1ad9ea5d.svg";